module.exports = __webpack_public_path__ + "img/1559424280.85da9b05.jpg";